import React from 'react';
import PropTypes from 'prop-types';

const PlatformFacebook = ({ monochrome, ...props }) => (
  <svg viewBox="0 0 456 456" height="1em" {...props}>
    <rect x="0" y="0" fill="currentColor" width="456" height="456" rx="50" />
    <path
      d="M 242.704,456 V 279.691 h -59.33 v -71.864 h 59.33 v -60.353 c 0,-43.893 35.582,-79.475 79.475,-79.475 h 62.025 v 64.622 h -44.382 c -13.947,0 -25.254,11.307 -25.254,25.254 v 49.953 h 68.521 l -9.47,71.864 H 314.568 V 456 Z"
      fill="#ffffff"
    />
  </svg>
);

PlatformFacebook.propTypes = {
  monochrome: PropTypes.bool,
};
PlatformFacebook.defaultProps = {
  monochrome: false,
};

export default PlatformFacebook;
